export abstract class WindowAccessor {
  constructor() {
  }

  public abstract get(): Window | null;
}
